export default __webpack_public_path__ + "static/media/close.7fe3635c.svg";